module.exports = "/assets/data/bbb868910d00d8cec381a5fe58856fd3-TD7.data.json";